import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../../config";
import Notification from "../../components/Notification.js";

const ProductView = () => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [lastMonthDebt, setLastMonthDebt] = useState({ total_no_of_items: 0, total_amount: 0 });
    const [thisMonthDebt, setThisMonthDebt] = useState({ total_no_of_items: 0, total_amount: 0 });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [notification, setNotification] = useState({ type: "", message: "" });
    const token = localStorage.getItem("access_token");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await fetch(`${API_URL}/products/${id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setProduct(data.product);
                    setLastMonthDebt(data.lastMonthDebt);
                    setThisMonthDebt(data.thisMonthDebt);
                } else if (response.status === 401) {
                    navigate("/logout");
                } else {
                    const errorData = await response.json();
                    setError(errorData || {});
                    setNotification({ message: errorData.message || "An error occurred.", type: "danger" });
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchProduct();
        }
    }, [id, token, navigate]);

    const closeNotification = () => {
        setNotification({ type: "", message: "" });
    };

    if (loading) return <p>Loading product details...</p>;
    if (error) return <p className="has-text-danger">{error}</p>;

    return (
        <div className="container">
            <div className="py-4">
                <h2 className="title is-4">Product Details</h2>

                {notification.message && (
                    <Notification
                        type={notification.type}
                        message={notification.message}
                        onClose={closeNotification}
                    />
                )}

                {product && (
                    <div className="card">
                        <div className="card-content">
                            <p className="title">{product.name}</p>
                            <p className="subtitle">KES {product.price}</p>
                          
                            <p><strong>Status:</strong> <span className={`tag ${product.status === 'Available' ? 'is-success' : 'is-danger'}`}>{product.status}</span></p>
                            <p><strong>Description:</strong> {product.description || "No description available"}</p>
  <hr/>
                            <div className="mt-5">
                                <h3 className="title is-5 mb-3">Sale Statistics</h3>
                                <div className="columns">
                                    <div className="column">
                                        <div className="box">
                                            <h4 className="title is-6">This Month</h4>
                                            <p><strong>Total Items:</strong> {thisMonthDebt.total_no_of_items}</p>
                                            <p><strong>Total Amount:</strong> KES {thisMonthDebt.total_amount}</p>
                                        </div>
                                    </div>
                                    <div className="column">
                                        <div className="box">
                                            <h4 className="title is-6">Last Month</h4>
                                            <p><strong>Total Items:</strong> {lastMonthDebt.total_no_of_items}</p>
                                            <p><strong>Total Amount:</strong> KES {lastMonthDebt.total_amount}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5">
                                <p><strong>Created At:</strong> {new Date(product.created_at).toLocaleString()}</p>
                                <p><strong>Updated At:</strong> {product.updated_at ? new Date(product.updated_at).toLocaleString() : "Not updated"}</p>
                            </div>
                        </div>
                    </div>
                )}
                <div className="buttons is-centered mt-4">
                    <Link className="button is-light" to="/dashboard/products">Back to Products</Link>
                </div>
            </div>
        </div>
    );
};

export default ProductView;